<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" nextButtonText="Próximo"
    backButtonText="Voltar" finishButtonText="Registar" @on-complete="formSubmitted">
    <tab-content title="Instituição" icon="feather icon-home">

      <!-- tab 1 content -->
      <div class="vx-row mb-1">
        <div class="vx-col w-full">
          <vs-input class="w-full" label-placeholder="Nome da empresa" v-model="name_company" />
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-input class="w-full" label-placeholder="Endereço" v-model="address" />
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col w-1/2">
          <vs-input class="w-full" type="number" label-placeholder="Telefone" v-model="company_phone" />
        </div>
        <div class="vx-col w-1/2">
          <vs-input class="w-full" type="number" label-placeholder="Funcionarios" v-model="employee_number" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input class="w-full" type="number" label-placeholder="NUIT" v-model="nuit" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-input class="w-full" type="number" label-placeholder="INSS" v-model="inss" />
        </div>
      </div>


    </tab-content>

    <!-- tab 2 content -->
    <tab-content title="Administrador" icon="feather icon-user">
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-input class="w-full" label-placeholder="Nome" v-model="name" />
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-input class="w-full" label-placeholder="Apelido" v-model="surname" />
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-input class="w-full" type="email" label-placeholder="Email" v-model="email" />
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-input class="w-full" label-placeholder="Telefone" type="number" v-model="phone" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" type="password" label-placeholder="Senha" v-model="password" />
        </div>
      </div>
      <!-- <vs-button  type="border" @click="formSubmitted">Registrar</vs-button> -->

    </tab-content>

    <!-- tab 3 content -->
    <tab-content title="Pagamento" class="mb-5" icon="feather icon-credit-card">
      <div class="vx-row">
        <!-- <div class="vx-col md:w-full w-full">
          <label class="mt-5" for="">Periodo</label>
          <select v-model="frequency" class="md: w-full block  pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
            <option class="vs__selected-options" value="Mensal">Mensal</option>
            <option class="vs__selected-options" value="Trimestral">Trimestal</option>
            <option class="vs__selected-options" value="Semestral">Semestral</option>
            <option class="vs__selected-options" value="Anual">Anual</option>
</select>
        </div> -->
        <div class="vx-col md:w-full w-full">
          <label class="mt-5" for="">Pacote</label>
          <select v-model="package_id" class="md: w-full block  pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
            <option class="vs__selected-options" v-for="option in pacotes" :value="option.id">
    {{ option.name }}
  </option>
  
</select>
        </div>
        <div class="vx-col md:w-full w-full mb-2">
          <label class="mt-5" for="">Metodo de pagamento</label>
          <div class="mt-2 ml-0 vx-row">
            <img src="./mpesa.png" alt="" height="30" class="mt-2">
            <vs-radio v-model="type" vs-value="Mpesa" class="ml-1 mr-1 mt-2">m-pesa</vs-radio>
            <img src="./emola.png" alt="" height="30" class="mt-2">
            <vs-radio v-model="type" vs-value="E-Mola" class="ml-1 mr-1 mt-2">e-mola</vs-radio>
            <img src="./deposito.png" alt="" height="30" class="mt-2">
            <vs-radio v-model="type" vs-value="Deposito" class="ml-1 mr-1 mt-2">Deposito</vs-radio>
          </div>
        </div>
        <div class="vx-col w-full mb-2" v-if="type='Mpesa'">
          <div class="mt-2">
            <vx-input-group class="mb-base">

              <vs-input class="w-full " type="number" placeholder="Numero de celular" v-model="phonePay" />
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span>+258</span>
                </div>
              </template>
            </vx-input-group>
          </div>
        </div>
        <!-- <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-select v-model="status" class="w-full select-large" label="Event Status">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in statusOptions" class="w-full" />
                  </vs-select>
              </div> -->
        <!-- <div class="vx-col md:w-1/2 w-full md:mt-8">
                  <div class="demo-alignment">
                      <span>Requirements:</span>
                      <div class="flex">
                        <vs-checkbox>Staffing</vs-checkbox>
                        <vs-checkbox>Catering</vs-checkbox>
                      </div>
                  </div>
              </div> -->
      </div>
    </tab-content>
    
  </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import http from "../../../../http-common";
import vSelect from 'vue-select'

export default{
  components:{
        vSelect
    },
  data() {
    return {
      
      firstName: "",
      name_company: "",
      company_phone: "",
      address: "",
      employee_number: "",
      name: "",
      surname: "",
      email: "",
      password: "",
      phone: "",
      err: "",
      msg: "",
      nuit: "",
      inss: "",
      company_employees:"",
      phonePay: "",
      type: "",

      selectedPackage:[],
      pacotes:[],
      package_id:"",
        type: "",
        license:"mTdnCY",
        package_id:"",
    }
  },

  mounted(){
this.getPackege()
  },
  methods: {
   
    registerUser() {
      this.$router.push('/pages/login').catch(() => { })
    },
    async formSubmitted() {
      this.$vs.loading()
      const data = {
        package_id: this.selectedPackage.id,
        type: this.type,
        cell:'258'+this.phonePay,

        license:this.$route.params.lisence,
        employee_number:this.employee_number,
        name_company: this.name_company,
        company_phone: this.company_phone,
        address: this.address,
        employes_number: this.employes_number,
        name: this.name,
        surname: this.surname,
        email: this.email,
        password: this.password,
        phone: this.phone,
        inss: this.inss,
        nuit: this.nuit,
        package_id: this.package_id,
        frequency:"Mensal"
      };
      await http
        .post("/auth/register", data)
        .then((success) => {
          success;
          this.$vs.loading.close()
          this.$vs.notify({
            title: "Sucesso",
            text: "Empresa Registada com sucesso",
            color: "success",
            position: "top-center",
          });
          this.$router.push({ name: 'page-login' })
            ;
        })
        .catch((error) => {

          error;
          this.$vs.loading.close()
          if (error.response.status == 422) {
            this.err = error.response.data
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            })
          } else {
            this.$vs.notify({
              title: "Erro",
              text: "Aconteceu algum erro",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            })
          }
        });
    },


    getPackege() {
    //   this.$vs.loading({
    //     container: '#div-with-loading',
    //     scale: 1.0,
    //     type: 'sound'
    //   })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
       

      };

      http
        .get("/auth/packages", config)
        .then((result) => {
        //   this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.pacotes = result.data
        
          // alert("2")
        })
        .catch((error) => {
          error;
          this.dataNotLoading = true
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

  },
  components: {
    FormWizard,
    TabContent
  }
}
</script>